<template>
  <nav
    aria-label="Breadcrumb"
    class="flex"
  >
    <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
      <li
        v-for="(crumb, index) in crumbs"
        :key="index"
        class="inline-flex items-center"
      >
        <a
          v-if="crumb.href"
          :href="crumb.href"
          class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white"
        >
          {{ crumb.text }}
        </a>
        <span
          v-else
          class="text-sm font-medium text-black dark:text-white"
        >{{ crumb.text }}</span>
        <svg
          v-if="index < crumbs.length - 1"
          aria-hidden="true"
          class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
          fill="none"
          viewBox="0 0 6 10"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m1 9 4-4-4-4"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';

export default defineComponent({
  name: 'Breadcrumb',
  props: {
    crumbs: {
      type: Array as PropType<{ href: string; text: string }[]>,
      required: true,
      default: () => []
    }
  }
});
</script>
